import { RootState } from '@/app/store';
import { DEFAULT_MARKET } from '@/shared/constants/constants';
import { EntityId, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

type Adapter = {
  id: number;
  market: string | EntityId;
};

const userSelectedMarketAdapter = createEntityAdapter<Adapter>();
export const initialState = userSelectedMarketAdapter.getInitialState({
  ids: [1],
  entities: {
    1: {
      market: DEFAULT_MARKET
    }
  }
});

export const userSelectedMarketSlice = createSlice({
  name: 'market',
  initialState: initialState,
  reducers: {
    userSelectedMarketAdd: userSelectedMarketAdapter.addOne,
    userSelectedMarketUpdate: userSelectedMarketAdapter.updateOne
  }
});

export const { userSelectedMarketAdd, userSelectedMarketUpdate } = userSelectedMarketSlice.actions;

export const selectedMarketSelector = userSelectedMarketAdapter.getSelectors<RootState>(
  (state: RootState) => state.userSelectedMarket ?? initialState
);
